export const GET_BLUE_SQUARE_EMAIL_ASSIGNMENTS = 'GET_BLUE_SQUARE_ASSIGNMENTS';
export const SET_BLUE_SQUARE_EMAIL_ASSIGNMENT = 'SET_BLUE_SQUARE_ASSIGNMENT';
export const DELETE_BLUE_SQUARE_EMAIL_ASSIGNMENT = 'DELETE_BLUE_SQUARE_ASSIGNMENT';
export const BLUE_SQUARE_EMAIL_ASSIGNMENT_ERROR = 'BLUE_SQUARE_EMAIL_ASSIGNMENT_ERROR';
